@if (cards().length) {
  <app-accordion-group>
    @for (item of cards(); track $index) {
      <app-accordion-item
        [expanded]='expanded'
        [name]="$index + 1 + '. Numer karty: ' + item?.cardNumber"
        [disabled]='false'>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Ulica:">
              {{ item?.street || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Nr domu:'>
              {{ item?.houseNumber || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Nr mieszkania:'>
              {{ item?.apartmentNumber || '-' }}
            </app-label>
          </div>
        </div>
        <div slot="action">
          @if (showActions()) {
            <button
              (click)='onEdit.emit({ v: item, i: $index }); $event.preventDefault()'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              type="button"
              [disabled]='!canEdit()'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              [disabled]='!canEdit()'
              type='button'
              class='btn btn-red-secondary icon-btn' title='Usuń z listy'
              (click)='onRemove.emit($index); $event.preventDefault()'>
              <i class='fa fa-trash-alt'></i>
            </button>
          }
        </div>
      </app-accordion-item>
    }
  </app-accordion-group>
} @else {
  <br>
  <app-alert type="info" [closable]="false"><strong>Brak dodanych posiadacze kart!</strong></app-alert>
}
